// leaf-town - art: creatures, pickups and effects. Everything is sculpted in code.
(function () {
  'use strict';
  const G = window.G;
  const K = '#1b1226';                       // the ink every outline uses
  const C = (G.COL = {
    ink: K, night: '#0d0a12', paper: '#f4ede0', dim: '#8d8798',
    accent: '#d77757', accentHi: '#f0a184', accentLo: '#a8512f', eye: '#1a1213',
    leaf: '#beee7a', leafMid: '#6cc04a', leafLo: '#468c34', leafHi: '#f0ffc8',
    gold: '#f2c14e', goldHi: '#fff1b8', goldLo: '#b9792a',
    hazard: '#ff4f6d', hazardHi: '#ffd0d6', hazardLo: '#a8183a',
    ok: '#7fd08a', okHi: '#d6ffd0', bad: '#ff5d5d', mint: '#58f0c8', sky: '#7cc4ff',
  });
  const S = (G.SPR = {});

  // firefly: a tiny helper that hunts bugs for you
  (() => {
    const mk = (up) => {
      const p = G.pix(10, 7);
      p.rect(1, 3, 3, 3, '#fff36e').rect(3, 3, 4, 3, '#a6e88f').rect(7, 2, 2, 3, '#3f8a55').px(8, 3, C.eye);
      if (up) p.rect(3, 0, 2, 3, '#e9f6ff').rect(5, 1, 2, 2, '#cfe0ff'); else p.rect(2, 2, 3, 1, '#e9f6ff').rect(5, 2, 2, 1, '#cfe0ff');
      return p.c;
    };
    S.agent = [mk(0), mk(1)];
  })();

  // ---------- claw swipe ----------
  function slashFrame(i, R, cols) {
    const N = R * 2 + 8, p = G.pix(N, N), cx = 3, cy = N / 2;
    const win = [[-82, 0], [-64, 64], [28, 84]][i];
    const maxTh = [5.2, 7, 2.6][i];
    for (let y = 0; y < N; y++) for (let x = 0; x < N; x++) {
      const dx = x + 0.5 - cx, dy = y + 0.5 - cy, d = Math.hypot(dx, dy);
      const a = (Math.atan2(dy, dx) * 180) / Math.PI;
      if (a < win[0] || a > win[1]) continue;
      const tt = (a - win[0]) / (win[1] - win[0]);
      const th = Math.pow(Math.sin(Math.PI * tt), 0.7) * maxTh, r = R - (1 - Math.sin(Math.PI * tt)) * 2;
      if (d <= r && d >= r - th) {
        const edge = r - d;
        p.px(x, y, i === 2 ? cols[1] : edge < 1.6 ? cols[0] : edge < th * 0.62 ? cols[1] : cols[2]);
      }
    }
    return p.c;
  }
  function rot90(img, n) {
    const c = G.makeCanvas(img.width, img.height);
    c.g.translate(img.width / 2, img.height / 2); c.g.rotate((Math.PI / 2) * n); c.g.drawImage(img, -img.width / 2, -img.height / 2);
    return c;
  }
  function slashSet(R, cols) {
    const f = [0, 1, 2].map((i) => slashFrame(i, R, cols));
    return { f, u: f.map((c) => rot90(c, 3)), d: f.map((c) => rot90(c, 1)), b: f.map((c) => G.flipX(c)) };
  }
  S.slash = slashSet(17, ['#ffffff', '#ffe2c4', '#f0a184']);
  S.slashBig = slashSet(22, ['#ffffff', '#fff1b8', '#f2c14e']);

  // ---------- creatures ----------
  function bug(f, c, spiky) {
    const p = G.pix(18, 15);
    p.ell(8.5, 9, 6, 4.2, c.a);
    p.clear(0, 12, 18, 3);
    p.rect(4, 10, 9, 2, c.b);
    p.ell(7, 7, 2.6, 1.2, c.l);
    p.line(10, 6, 11, 10, c.b);
    p.ell(14, 9.5, 2.3, 2.4, c.b);
    p.px(14, 8, '#fff').px(15, 8, c.eye || '#ffe36e').px(14, 9, c.eye || '#ffe36e');
    p.px(15, 6, K).px(16, 5, K).px(13, 5, K).px(13, 4, K);
    const L = f ? [4, 8, 12] : [5, 9, 11];
    L.forEach((x, i) => p.rect(x, 12, 1, (i + f) % 2 ? 1 : 2, K));
    if (spiky) { [[5, 5], [8, 4], [11, 5]].forEach(([x, y]) => p.px(x, y, '#fff').px(x, y + 1, c.l).px(x - 1, y + 1, c.l).px(x + 1, y + 1, c.l)); }
    p.outline(K);
    return p.c;
  }
  const BUG = { a: '#a9dd52', b: '#5f9a2c', l: '#e3ffa0' };
  const REG = { a: '#e0568a', b: '#8c2356', l: '#ffc2d8', eye: '#fff36e' };
  S.bug = [bug(0, BUG), bug(1, BUG)];
  S.spiky = [bug(0, REG, 1), bug(1, REG, 1)];

  function typo(air) {
    const p = G.pix(14, 15), y = air ? 1 : 4, h = air ? 10 : 8;
    p.rect(2, y, 10, h, '#b79cff').rect(3, y - 1, 8, 1, '#b79cff');
    p.rect(2, y + h - 2, 10, 2, '#7a5fd0');
    p.rect(3, y, 6, 1, '#e2d6ff');
    p.px(4, y + 2, K).px(5, y + 3, K).px(4, y + 3, K);
    p.px(9, y + 2, K).px(8, y + 3, K).px(9, y + 3, K);
    p.rect(5, y + 5, 4, 1, K).px(5, y + 6, K);            // crooked mouth
    if (air) { p.rect(3, 11, 2, 3, '#7a5fd0').rect(9, 11, 2, 3, '#7a5fd0'); }
    else { p.rect(2, 12, 3, 1, '#7a5fd0').rect(9, 12, 3, 1, '#7a5fd0'); }
    p.outline(K);
    return p.c;
  }
  S.typo = [typo(0), typo(1)];

  function flaky(w, angry) {
    const p = G.pix(18, 14), a = angry ? '#ff6b5e' : '#8fe3a0', b = angry ? '#a3252f' : '#3f9a62';
    if (w) { p.ell(4, 4.5, 3.2, 2.2, '#e9f6ff').ell(14, 4.5, 3.2, 2.2, '#e9f6ff'); }
    else { p.ell(4.5, 8, 3.2, 1.8, '#e9f6ff').ell(13.5, 8, 3.2, 1.8, '#e9f6ff'); }
    p.ell(9, 8, 4, 4, a);
    p.rect(6, 10, 6, 2, b);
    p.px(7, 7, '#fff').px(11, 7, '#fff').px(7, 8, K).px(11, 8, K);
    if (angry) { p.px(6, 5, K).px(7, 6, K).px(12, 5, K).px(11, 6, K); }
    p.outline(K);
    return p.c;
  }
  S.flaky = [flaky(0, 0), flaky(1, 0)];
  S.flakyMad = [flaky(0, 1), flaky(1, 1)];

  function lint(f) {
    const p = G.pix(17, 17), cx = 8.5, cy = 8.5;
    for (let i = 0; i < 8; i++) {
      const a = (i / 8) * Math.PI * 2 + (f ? Math.PI / 8 : 0);
      p.line(cx - 0.5 + Math.cos(a) * 4, cy - 0.5 + Math.sin(a) * 4, cx - 0.5 + Math.cos(a) * 7, cy - 0.5 + Math.sin(a) * 7, '#d9cfe8');
    }
    p.ell(cx, cy, 5, 5, '#8f86a8');
    p.ell(cx - 1, cy - 1.5, 3, 2.2, '#b9b0d0');
    p.ell(cx, cy + 0.5, 2.2, 2.2, '#fff');
    p.rect(8, 8, 2, 2, K);
    p.outline(K);
    return p.c;
  }
  S.lint = [lint(0), lint(1)];

  function logger(open) {
    const p = G.pix(18, 18);
    p.rect(7, 13, 4, 3, '#5a5470').rect(4, 15, 10, 2, '#3d3852');           // stand
    p.rect(2, 2, 14, 11, '#cfc6b4').rect(2, 11, 14, 2, '#9c9484');           // beige monitor
    p.rect(4, 4, 10, 7, '#16241c');
    p.px(6, 6, '#7dff9a').px(11, 6, '#7dff9a');
    if (open) p.rect(6, 8, 6, 2, '#7dff9a'); else p.rect(6, 9, 6, 1, '#7dff9a');
    p.px(14, 12, '#ff5d5d');
    p.outline(K);
    return p.c;
  }
  S.logger = [logger(0), logger(1)];

  function mimic(state) {
    const p = G.pix(20, 20), y = state === 2 ? 1 : 3;
    p.rect(2, y, 16, 14, '#c08a4e');
    p.rect(2, y, 16, 2, '#e5b878').rect(2, y + 12, 16, 2, '#8c5e36');
    p.rect(9, y, 2, 14, '#e9d2a6');                                           // tape
    p.rect(4, y + 8, 4, 1, '#8c5e36').rect(4, y + 10, 3, 1, '#8c5e36');       // label
    p.line(12, y + 9, 16, y + 11, '#b8343f').line(12, y + 11, 16, y + 9, '#b8343f'); // "deprecated" strike
    if (state > 0) {
      p.rect(4, y + 3, 4, 3, '#fff').rect(12, y + 3, 4, 3, '#fff');
      p.rect(6, y + 4, 2, 2, K).rect(12, y + 4, 2, 2, K);
      p.rect(4, y + 2, 4, 1, K).rect(12, y + 2, 4, 1, K);
      const ly = y + 14;
      p.rect(4, ly, 3, state === 2 ? 4 : 2, '#8c5e36').rect(13, ly, 3, state === 2 ? 4 : 2, '#8c5e36');
    }
    p.outline(K);
    return p.c;
  }
  S.mimic = [mimic(0), mimic(1), mimic(2)];

  function noodle(f, mad) {
    const p = G.pix(20, 14), a = mad ? '#ffb347' : '#f6d76b', b = mad ? '#c8641e' : '#c39a2e';
    // a tangle of loops
    const loops = [[6, 8, 4, 3], [11, 7, 4.5, 3.5], [14, 9, 3, 2.5], [9, 9.5, 3, 2]];
    loops.forEach(([x, y, rx, ry], i) => { p.ell(x + (f && i % 2 ? 1 : 0), y, rx, ry, i % 2 ? b : a); });
    p.ell(10, 8, 5.5, 3, a);
    p.line(4, 8, 8, 6, b).line(8, 10, 13, 8, b).line(12, 6, 16, 9, b);
    p.rect(14, 6, 2, 2, '#fff').px(15, 7, K).rect(11, 5, 2, 2, '#fff').px(12, 6, K);
    if (mad) { p.px(10, 4, K).px(11, 4, K).px(14, 5, K).px(15, 4, K); }
    p.px(2 - (f ? 0 : 1) + 1, 10, a).px(1, 11, a);                            // loose end
    p.outline(K);
    return p.c;
  }
  S.noodle = [noodle(0, 0), noodle(1, 0), noodle(0, 1), noodle(1, 1)];

  function slime(f, small) {
    const w = small ? 12 : 18, h = small ? 10 : 14, p = G.pix(w, h);
    const cx = w / 2, by = h - 1, rx = (small ? 4 : 7) + (f ? 0.6 : 0), ry = (small ? 3.4 : 5.4) - (f ? 0.5 : 0);
    p.ell(cx, by - ry + 0.5, rx, ry, '#58f0c8');
    p.clear(0, by, w, 2);
    p.ell(cx - rx * 0.3, by - ry * 1.3, rx * 0.35, ry * 0.25, '#d2fff2');
    p.rect(cx - rx + 1, by - 2, rx * 2 - 2, 1, '#1b9a8c');
    const ey = Math.round(by - ry);
    p.px(Math.round(cx - 2), ey, K).px(Math.round(cx + 1), ey, K);
    if (!small) { p.px(Math.round(cx - 2), ey + 1, K).px(Math.round(cx + 1), ey + 1, K); p.ell(cx, by - 2.6, 1.6, 1.2, '#1b9a8c'); }
    p.outline('#0c4f58');
    return p.c;
  }
  S.slime = [slime(0, 0), slime(1, 0)];
  S.slimeS = [slime(0, 1), slime(1, 1)];

  function ghost(f, shy) {
    const p = G.pix(18, 18);
    p.ell(9, 8, 6, 6, '#cfe6ff');
    p.rect(3, 8, 12, 6, '#cfe6ff');
    for (let i = 0; i < 4; i++) p.rect(3 + i * 3 + (f ? 1 : 0), 14, 2, 2, '#cfe6ff');
    p.ell(7, 5, 2.5, 1.5, '#ffffff');
    if (shy) {
      p.rect(4, 7, 4, 3, '#9fc0ea').rect(10, 7, 4, 3, '#9fc0ea');              // little hands over the eyes
      p.px(8, 11, K).px(9, 11, K);
    } else {
      p.rect(6, 7, 2, 3, K).rect(11, 7, 2, 3, K);
      p.px(6, 7, '#ff5d7a').px(11, 7, '#ff5d7a');
      p.rect(8, 11, 3, 2, K);
    }
    p.outline('#4a5f9a');
    return p.c;
  }
  S.ghost = [ghost(0, 0), ghost(1, 0), ghost(0, 1)];

  function racer(f) {
    const p = G.pix(20, 12);
    p.shape((x, y) => { const dx = (x - 10) / 8, dy = (y - 6) / 3.6; return dx * dx + dy * dy < 1 && x > 3; }, '#ffb347');
    p.rect(5, 7, 10, 2, '#c8641e');
    p.rect(13, 4, 3, 2, '#fff').px(15, 5, K).px(15, 4, K);
    p.rect(6, 3, 5, 1, '#ffe2a8');
    p.rect(1 + (f ? 1 : 0), 4, 3, 1, '#ffe2a8').rect(0 + (f ? 0 : 1), 7, 4, 1, '#ffe2a8');   // speed lines
    p.rect(7 + (f ? 1 : 0), 10, 2, 1, K).rect(12 - (f ? 1 : 0), 10, 2, 1, K);
    p.outline(K);
    return p.c;
  }
  S.racer = [racer(0), racer(1)];

  function drone(f, hot) {
    const p = G.pix(20, 16);
    p.rect(2 + (f ? 2 : 0), 2, 6 - (f ? 4 : 0), 1, '#d6dbe8').rect(12 + (f ? 2 : 0), 2, 6 - (f ? 4 : 0), 1, '#d6dbe8');
    p.rect(4, 3, 2, 2, '#5c6378').rect(14, 3, 2, 2, '#5c6378');
    p.rect(3, 5, 14, 6, '#8a92a8').rect(3, 9, 14, 2, '#5c6378').rect(4, 5, 12, 1, '#c5cbdb');
    p.ell(10, 11, 3.2, 3, '#2a2d3a');
    p.ell(10, 11.5, 1.6, 1.6, hot ? '#ffffff' : '#ff5d5d');
    p.px(5, 7, hot ? '#fff36e' : '#ffb347').px(15, 7, hot ? '#fff36e' : '#ffb347');
    p.outline(K);
    return p.c;
  }
  S.drone = [drone(0, 0), drone(1, 0), drone(0, 1), drone(1, 1)];

  // ---------- hazards ----------
  (() => {
    const p = G.pix(19, 19);
    for (let i = 0; i < 8; i++) { const a = (i / 8) * Math.PI * 2; p.line(9 + Math.cos(a) * 5, 9 + Math.sin(a) * 5, 9 + Math.cos(a) * 8, 9 + Math.sin(a) * 8, C.hazardHi); }
    p.ell(9.5, 9.5, 6, 6, C.hazard).ell(8, 8, 3, 2.4, '#ff8ea0').ell(9.5, 11.5, 4, 2.5, C.hazardLo).ell(9.5, 9.5, 2, 2, K);
    p.outline(K);
    S.pendulum = p.c;
  })();
  S.gear = [];
  for (let k = 0; k < 6; k++) {
    const N = 27, p = G.pix(N, N), c = N / 2, teeth = 8, rot = (k / 6) * ((Math.PI * 2) / teeth);
    p.shape((x, y) => {
      const dx = x - c, dy = y - c, d = Math.hypot(dx, dy), a = Math.atan2(dy, dx) + rot;
      const tooth = Math.cos(a * teeth) > 0.2;
      return d < (tooth ? 12.4 : 9.4);
    }, '#c9ced9');
    p.shape((x, y) => { const d = Math.hypot(x - c, y - c); return d < 8 && d > 6.6; }, '#8b91a3');
    p.shape((x, y) => Math.hypot(x - c, y - c) < 3, K);
    p.rim('#ffffff', '#7a8094');
    p.outline(K);
    S.gear.push(p.c);
  }

  // ---------- pickups ----------
  S.token = [3, 2.2, 1, 2.2].map((rx, i) => {
    const p = G.pix(9, 9);
    p.ell(4.5, 4.5, rx, 3, C.gold);
    if (rx > 1.5) { p.ell(4.5 - rx * 0.25, 3.6, rx * 0.5, 1.2, C.goldHi); p.rect(4, 5, 1, 2, C.goldLo); }
    if (i === 0) p.rect(3, 4, 3, 1, C.goldLo);
    p.outline(K);
    return p.c;
  });
  // leaf: the collectible of 풀잎 마을 (save key stays 'sparks'). Drawn along a tilted axis: round base, pointed tip, a vein, a stem.
  // pal: [light half, shaded half, edge, vein/stem, rim highlight]
  function leafPix(N, cx, cy, half, W, vein, pal) {
    const p = G.pix(N, N), ca = Math.SQRT1_2, sa = -Math.SQRT1_2;   // tip points up-right
    for (let y = 0; y < N; y++) for (let x = 0; x < N; x++) {
      const dx = x + 0.5 - cx, dy = y + 0.5 - cy, u = dx * ca + dy * sa, v = -dx * sa + dy * ca;
      const s = (u + half) / (2 * half);
      if (s < 0 || s > 1) continue;
      const w = (W * Math.sqrt(s) * (1 - s)) / 0.385, e = w - Math.abs(v);   // widest a third of the way up
      if (e < 0) continue;
      p.px(x, y, vein && Math.abs(v) < 0.55 && s > 0.12 && s < 0.8 ? pal[3] : v < 0 ? (e < 0.8 && s > 0.2 && s < 0.7 ? pal[4] : pal[0]) : e < 0.8 ? pal[2] : pal[1]);
    }
    const sx = Math.floor(cx - ca * (half + 0.2)), sy = Math.floor(cy - sa * (half + 0.2));
    p.px(sx, sy, pal[3]).px(sx - 1, sy + 1, pal[3]);
    return p;
  }
  const LEAF = [C.leaf, C.leafMid, C.leafLo, '#346e2c', C.leafHi];
  // frame 1 glints: the rim goes white and a twinkle sits off the tip
  S.leaf = [0, 1].map((f) => {
    const p = leafPix(15, 8, 7, 6.3, 3, true, f ? [C.leaf, C.leafMid, C.leafLo, '#346e2c', '#ffffff'] : LEAF);
    p.outline('#1f3a1c');
    if (f) p.px(13, 0, '#fff3e4').px(12, 1, '#fff3e4').px(14, 1, '#fff3e4').px(13, 2, '#fff3e4');
    return p.c;
  });
  S.leafGhost = S.leaf.map((s) => G.tint(s, '#5a5568'));
  // tiny versions for the hud
  S.leafSm = ['on', 'had', 'off'].map((k) => {
    const pal = k === 'on' ? LEAF : k === 'had' ? ['#7d9a62', '#5f7a4a', '#4c6340', '#3e5236', '#93ad78'] : ['#3a3346', '#3a3346', '#3a3346', '#2c2638', '#3a3346'];
    const p = leafPix(9, 4.8, 4.2, 3.6, 1.9, true, pal);
    p.outline(K);
    return p.c;
  });
  (() => {
    const p = G.pix(12, 12);
    p.rect(2, 4, 7, 6, '#f4ede0').rect(2, 9, 7, 1, '#c9bfae').rect(3, 5, 5, 1, '#6b3b23');
    p.rect(9, 5, 2, 1, '#f4ede0').rect(10, 6, 1, 2, '#f4ede0').rect(9, 8, 2, 1, '#f4ede0');
    p.px(4, 2, '#cfc7d8').px(5, 1, '#cfc7d8').px(7, 2, '#cfc7d8');
    p.rect(4, 7, 3, 1, C.accent);
    p.outline(K);
    S.coffee = p.c;
  })();
  // hp pip: a little leaf
  S.pip = (() => { const p = G.pix(8, 8); p.rect(2, 1, 5, 4, '#7fd08a').rect(1, 3, 5, 3, '#7fd08a').rect(3, 1, 3, 1, '#c6f2a8').rect(2, 5, 3, 1, '#3f8a55').px(1, 6, '#3f8a55').px(4, 3, '#3f8a55').px(3, 4, '#3f8a55'); p.outline(K); return p.c; })();
  S.pipOff = (() => { const p = G.pix(8, 8); p.rect(1, 1, 6, 6, '#3a3346'); p.rect(2, 2, 4, 4, '#231d2e'); p.outline(K); return p.c; })();

  // ---------- level furniture ----------
  S.checkpoint = [0, 1].map((on) => {
    const p = G.pix(16, 28);
    p.rect(7, 9, 2, 18, on ? '#7fd08a' : '#6b6578').rect(5, 26, 6, 2, on ? '#3f8a55' : '#4a4458');
    p.ell(8, 6, 4.6, 4.6, on ? '#7fd08a' : '#6b6578');
    p.ell(8, 6, 2.6, 2.6, on ? '#eaffea' : '#231d2e');
    if (on) { p.px(7, 6, '#2c7a44').px(8, 7, '#2c7a44').px(9, 5, '#2c7a44').px(10, 4, '#2c7a44'); }
    p.outline(K);
    return p.c;
  });
  S.sign = (() => {
    const p = G.pix(16, 18);
    p.rect(7, 11, 2, 6, '#6b4a3a');
    p.rect(2, 2, 12, 9, '#2a2338').rect(3, 3, 10, 7, '#161020');
    p.px(5, 5, '#7dff9a').px(6, 6, '#7dff9a').px(5, 7, '#7dff9a').rect(8, 7, 3, 1, '#7dff9a');
    p.outline(K);
    return p.c;
  })();
  S.spring = [0, 1].map((up) => {
    const p = G.pix(16, 14), top = up ? 1 : 7;
    p.rect(2, 11, 12, 2, '#5c6378');
    for (let y = top + 2; y < 11; y += 2) p.rect(4 + (((y - top) / 2) & 1 ? 1 : 0), y, 7, 1, '#c5cbdb');
    p.rect(1, top, 14, 2, C.hazard).rect(1, top, 14, 1, '#ff9aab');
    p.outline(K);
    return p.c;
  });
  // terminal gate at the end of every level
  S.gate = (() => {
    const p = G.pix(30, 40);
    p.rect(2, 4, 26, 35, '#2a2338').rect(2, 4, 26, 4, '#4a4160');
    p.px(5, 5, '#ff5d5d').px(8, 5, '#f2c14e').px(11, 5, '#7fd08a').px(5, 6, '#ff5d5d').px(8, 6, '#f2c14e').px(11, 6, '#7fd08a');
    p.rect(4, 10, 22, 29, '#0b1410');
    p.outline(K);
    return p.c;
  })();
  // small key caps for tutorial signs
  G.keycap = (g, x, y, label, col) => {
    const w = Math.max(11, G.textW(label, { tiny: true }) + 6);
    G.panel(g, x, y, w, 11, '#f4ede0', '#1b1226', '#b7ab98');
    G.text(g, label, x + w / 2 + 0.5, y + 3, col || '#1b1226', { tiny: true, align: 'c' });
    return w;
  };

  // ---------- sheet for eyeballing everything (dev) ----------
  G.debugSheet = (g) => {
    g.fillStyle = '#2b2438'; g.fillRect(0, 0, G.W, G.H);
    let x = 4, y = 4, rowH = 0;
    const put = (img) => { if (!img || !img.width) return; if (x + img.width > G.W - 4) { x = 4; y += rowH + 3; rowH = 0; } g.drawImage(img, x, y); x += img.width + 3; rowH = Math.max(rowH, img.height); };
    for (const k in S) {
      const v = S[k];
      if (Array.isArray(v)) v.forEach(put);
      else if (v && v.f) { v.f.forEach(put); }
      else if (v && v.width) put(v);
    }
    G.CRITTERS.forEach((k, i) => { G.drawCritter(g, 20 + i * 22, 200, { kind: k.id }); G.drawCritter(g, 160 + i * 36, 140, { kind: k.id, u: 2, armL: -2, armR: -2 }); });
    G.text(g, 'The quick brown fox jumps over the lazy dog. 0123456789', 4, 150, '#f4ede0');
    G.text(g, 'SPHINX OF BLACK QUARTZ, JUDGE MY VOW! (x+y)*2 = [ok] {a;b} <c> #$%&@ ~/src', 4, 162, '#f2c14e');
    G.text(g, '✓ passed ✗ failed ▌ → ← ↑ ↓ ❦ … • ♦ ♥ ● ○ ▸ "it\'s" _under_', 4, 174, '#7fd08a');
    G.text(g, 'TINY FONT 0123456789 ABCDEFGHIJKLMNOPQRSTUVWXYZ .:-/!?+%', 240, 200, '#f4ede0', { tiny: true });
  };
})();

